<div style="box-sizing: border-box; display: flex; flex: 1 1 0%; flex-direction: column">
  <!--Contact Detail Toolbar-->
  <mat-toolbar color="primary" class="toolbar-over-card">
    <div style="box-sizing: border-box; display: flex; flex: 1 1 0%; place-content: center flex-start; align-items: center;">
      <mat-card-title>Contact Information</mat-card-title>
    </div>
    <div style="box-sizing: border-box; display: flex; flex: 1 1 0%; place-content: center flex-end; align-items: center; margin-bottom: 8px;">
      <button mat-icon-button matTooltip="More...." [matMenuTriggerFor]="contactMenu"><mat-icon>more_vert</mat-icon></button>
      <input type="file" class="file-input" (change)="onFileSelected($event)" style="display: none" #fileUpload>
      <mat-menu #contactMenu="matMenu">
        <button mat-menu-item (click)="onExportContacts()"><mat-icon>file_download</mat-icon> Export To Excel</button>
        <button mat-menu-item *ngIf="canEdit" (click)="fileUpload.click()"><mat-icon>file_upload</mat-icon> Import Contacts</button>
      </mat-menu>
    </div>
  </mat-toolbar>
  <!--Contact Detail Content-->
  <div style="flex: 1 1 0%; box-sizing: border-box;">
    <mat-card>
      <div style="font-size: 15px" *ngIf="!contact && showSelect">
        Please select a contact
      </div>
      <div style="font-size: 15px" *ngIf="!contact && !showSelect">
        Please create a contact
      </div>
      <mat-card-content *ngIf="contact">
        <form [formGroup]="caseContactForm">
          <div class="row" style="flex-direction: row; box-sizing: border-box; display: flex; place-content: baseline flex-start; align-items: flex-start; gap: 10px;">
            <div style="flex: 1 1 100%; box-sizing: border-box; max-width: 32%">
              <mat-form-field style="width:100%">
                <mat-label>Type</mat-label>
                <mat-select class="mat-select-icon" formControlName="isOrganization">
                  <mat-select-trigger>
                    <mat-icon style="vertical-align: middle; margin-right: 16px">{{ caseContactForm.controls['isOrganization'].value ? 'store_mall_directory' : 'face' }}</mat-icon>
                    <span style="vertical-align: middle; margin: 5px">{{ caseContactForm.controls['isOrganization'].value ? 'Organization' : 'Person' }}</span>
                  </mat-select-trigger>
                  <mat-option [value]="false">
                    <mat-icon>face</mat-icon>
                    <span style="margin:5px">Person</span>
                  </mat-option>
                  <mat-option [value]="true">
                    <mat-icon>store_mall_directory</mat-icon>
                    <span style="margin:5px">Organization</span>
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
          <div class="row" style="box-sizing: border-box; display: flex; flex: 1 1 0%; gap: 20px; place-content: end space-between; align-items: end; ">
            <div style="flex: 1 1 0%; box-sizing: border-box;">
              <mat-form-field class="full-width">
                <mat-label>Name</mat-label>
                <input matInput placeholder="Name" formControlName="name" [readonly]="!canEdit">
                <mat-error *ngIf="caseContactForm.controls['name'].invalid && (caseContactForm.controls['name'].touched || caseContactForm.controls['name'].dirty)">
                  <p *ngIf="caseContactForm.controls['name'].errors.required">Name is <strong>required</strong></p>
                  <p *ngIf="caseContactForm.controls['name'].errors.maxlength">Name can not exceed <strong>256</strong> characters.</p>
                </mat-error>
              </mat-form-field>
            </div>
            <div style="flex: 1 1 0%; box-sizing: border-box;">
              <mat-form-field class="full-width">
                <mat-label>Email</mat-label>
                <input matInput placeholder="Email" formControlName="email" [readonly]="!canEdit">
                <mat-error *ngIf="caseContactForm.controls['email'].errors && (caseContactForm.controls['email'].touched || caseContactForm.controls['email'].dirty)">
                  <p *ngIf="caseContactForm.controls['email'].errors.email">Email must be a valid email.</p>
                  <p *ngIf="caseContactForm.controls['email'].errors.maxlength">Email can not exceed <strong>50</strong> characters.</p>
                </mat-error>
              </mat-form-field>
            </div>
            <div style="flex: 1 1 0%; box-sizing: border-box;">
              <mat-form-field class="full-width">
                <mat-label>Job Title</mat-label>
                <input matInput placeholder="Job Title" formControlName="title" [readonly]="!canEdit">
                <mat-error *ngIf="caseContactForm.controls['title'].errors && (caseContactForm.controls['title'].touched || caseContactForm.controls['title'].dirty)">
                  <p *ngIf="caseContactForm.controls['title'].errors.maxlength">Job Title can not exceed <strong>50</strong> characters.</p>
                </mat-error>
              </mat-form-field>
            </div>
          </div>
          <div class="row" style="box-sizing: border-box; display: flex; flex: 1 1 0%; gap: 20px; place-content: end space-between; align-items: end; ">
            <div style="flex: 1 1 100%; box-sizing: border-box; max-width: 68%">
              <mat-form-field class="full-width">
                <mat-label>Address</mat-label>
                <input matInput placeholder="Address" formControlName="address" [readonly]="!canEdit">
                <mat-error *ngIf="caseContactForm.controls['address'].errors && (caseContactForm.controls['address'].touched || caseContactForm.controls['address'].dirty)">
                  <p *ngIf="caseContactForm.controls['address'].errors.maxlength">Address can not exceed <strong>256</strong> characters.</p>
                </mat-error>
              </mat-form-field>
            </div>
            <div style="flex: 1 1 100%; box-sizing: border-box; max-width: 32%">
              <mat-form-field class="full-width">
                <mat-label>Affiliation</mat-label>
                <input type="text"
                       placeholder="Type entry or select from list"
                       aria-label="Affiliation"
                       matInput
                       formControlName="affiliation"
                       [matAutocomplete]="auto"
                       [readonly]="!canEdit">
                <mat-autocomplete #auto="matAutocomplete">
                  <mat-option *ngFor="let selected of filteredAffiliations | async" [value]="selected">
                    {{selected}}
                  </mat-option>
                </mat-autocomplete>
                <mat-error *ngIf="caseContactForm.controls['affiliation'].errors && (caseContactForm.controls['affiliation'].touched || caseContactForm.controls['affiliation'].dirty)">
                  <p *ngIf="caseContactForm.controls['affiliation'].errors.maxlength">Affiliation can not exceed <strong>256</strong> characters.</p>
                </mat-error>
              </mat-form-field>
            </div>
          </div>
          <div class="row" style="box-sizing: border-box; display: flex; flex: 1 1 0%; gap: 20px; place-content: end space-between; align-items: end; ">
            <div style="flex: 1 1 0%; box-sizing: border-box;">
              <mat-form-field class="full-width">
                <mat-label>Cell</mat-label>
                <input matInput placeholder="Cell" formControlName="cell" [readonly]="!canEdit">
                <mat-error *ngIf="caseContactForm.controls['cell'].errors && (caseContactForm.controls['cell'].touched || caseContactForm.controls['cell'].dirty)">
                  <p *ngIf="caseContactForm.controls['cell'].errors.maxlength">Cell can not exceed <strong>50</strong> characters.</p>
                </mat-error>
              </mat-form-field>
            </div>
            <div style="flex: 1 1 0%; box-sizing: border-box;">
              <mat-form-field class="full-width">
                <mat-label>Phone</mat-label>
                <input matInput placeholder="Phone" formControlName="phone" [readonly]="!canEdit">
                <mat-error *ngIf="caseContactForm.controls['phone'].errors && (caseContactForm.controls['phone'].touched || caseContactForm.controls['phone'].dirty)">
                  <p *ngIf="caseContactForm.controls['phone'].errors.maxlength">Phone can not exceed <strong>50</strong> characters.</p>
                </mat-error>
              </mat-form-field>
            </div>
            <div style="flex: 1 1 0%; box-sizing: border-box;">
              <mat-form-field class="full-width">
                <mat-label>Fax</mat-label>
                <input matInput placeholder="Fax" formControlName="fax" [readonly]="!canEdit">
                <mat-error *ngIf="caseContactForm.controls['fax'].errors && (caseContactForm.controls['fax'].touched || caseContactForm.controls['fax'].dirty)">
                  <p *ngIf="caseContactForm.controls['fax'].errors.maxlength">Fax can not exceed <strong>50</strong> characters.</p>
                </mat-error>
              </mat-form-field>
            </div>
          </div>
          <div class="row" style="box-sizing: border-box; display: flex; flex: 1 1 0%; gap: 20px; place-content: end space-between; align-items: end; ">
            <div style="flex: 1 1 0%; box-sizing: border-box;">
              <mat-form-field class="full-width">
                <mat-label>Memo</mat-label>
                <textarea matInput rows="4" placeholder="Memo" formControlName="memo" [readonly]="!canEdit"></textarea>
                <mat-error *ngIf="caseContactForm.controls['memo'].errors && (caseContactForm.controls['memo'].touched || caseContactForm.controls['memo'].dirty)">
                  <p *ngIf="caseContactForm.controls['memo'].errors.maxlength">Memo can not exceed <strong>1024</strong> characters.</p>
                </mat-error>
              </mat-form-field>
            </div>
          </div>
        </form>
      </mat-card-content>
      <mat-card-actions *ngIf="contact && canEdit">
        <div style="box-sizing: border-box; display: flex; flex: 1 1 0%; place-content: center flex-end; align-items: center;">
          <button mat-button color="primary" [disabled]="caseContactForm.invalid || caseContactForm.pristine" type="submit" (click)="onUpdateContact()">Save</button>
          <button mat-button color="primary" [disabled]="caseContactForm.pristine" type="button" (click)="onUndo()">Cancel</button>
        </div>
      </mat-card-actions>
    </mat-card>
  </div>
</div>
